export { default, TestSelector as ShimmerFillTestSelector } from './ShimmerFill';
